/*
 * @providesModule withParams
 *
 */

import {useCallback, useEffect, useState, ComponentType, memo} from 'react';
import {usePathname, useParams} from 'solito/navigation';
import LoadingIndicator from 'LoadingIndicator';
import {Platform} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {SCREEN_PARAMS_PREFIX} from './SkillzRouter';

export default function withParams<Params extends Record<string, any>>(
  Component: ComponentType<Params>
) {
  return memo(function LoadParams(directParams: Params) {
    const pathname = usePathname();
    const [params, setParams] = useState<Params | null>(null);
    const dynamicParams = useParams<Params>();
    const getScreenParams = useCallback(async () => {
      try {
        const sanitizedPathname = pathname!.replace(/\/+$/, ''); // Removes only trailing slashes
        const params = await AsyncStorage.getItem(`${SCREEN_PARAMS_PREFIX}${sanitizedPathname}`);
        return JSON.parse(params || '{}');
      } catch (e) {
        console.error(e);
        return {};
      }
    }, [pathname]);
    useEffect(() => {
      async function didMount() {
        try {
          const screenParams = await getScreenParams();
          setParams({...screenParams, ...dynamicParams, currentScreen: pathname});
        } catch (e) {
          console.error(e);
        }
      }
      didMount();
    }, []);
    if (!params) {
      return null;
    }
    return <Component {...params} {...directParams} />;
  });
}
